/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type ReturnPage_viewer$ref = any;
export type queries_ReturnPage_QueryVariables = {};
export type queries_ReturnPage_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": ReturnPage_viewer$ref;
    }) | null;
};
export type queries_ReturnPage_Query = {
    readonly response: queries_ReturnPage_QueryResponse;
    readonly variables: queries_ReturnPage_QueryVariables;
};



/*
query queries_ReturnPage_Query {
  viewer {
    id
    ...ReturnPage_viewer
  }
}

fragment ReturnPage_viewer on Viewer {
  user {
    id
    role
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "queries_ReturnPage_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "ReturnPage_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "queries_ReturnPage_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "queries_ReturnPage_Query",
            "id": null,
            "text": "query queries_ReturnPage_Query {\n  viewer {\n    id\n    ...ReturnPage_viewer\n  }\n}\n\nfragment ReturnPage_viewer on Viewer {\n  user {\n    id\n    role\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'a0f961087b1d7722896e69f71a4329d8';
export default node;
